const cart = document.querySelector('.js-minicart');

function addToCart(elem) {

    elem = this;
    let id = this.dataset.id;

    let data = {
        id: id
    }

    const cartCount = document.querySelectorAll('.js-cart-count');
    elem.classList.add('loading');

    console.log(elem);



    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {

            $.getJSON('/cart.js', function (cart) {
                cartCount.forEach((elem) => {
                    elem.textContent = cart.item_count;
                });
            });

            elem.classList.remove('loading');

            updateCart();
            openCart();

        },
        error: function (e) {
            console.log('error: ', e);
        }

    });

};


function updateCart() {

    let $html = [];

    const cartItems = document.querySelector('.js-minicart-items'),
        cartTotal = document.querySelector('.js-minicart-total'),
        cartCount = document.querySelectorAll('.js-cart-count');

    $.ajax({
        type: 'GET',
        url: '/cart?view=data.json',
        success: function (data) {

            json_response = JSON.parse(data);

            let subtotal = json_response.subtotal;

            Array.prototype.forEach.call(json_response.items, function (item, index) {

                console.log(item);

                let id = item.id,
                    url = item.url,
                    image = item.image,
                    alt = item.alt,
                    title = item.title,
                    variant = '',
                    quantity = item.quantity,
                    money = item.subtotal;

                  if (item.variant_title !== "Default Title") {
                    variant = item.variant_title;
                  }

                let $item = `
                <div class="minicart__item js-item" data-id="${ id }">
                    <a class="minicart__item-image" href="${ url }">
                        <img loading="lazy" src="${ image }"
                            alt="${ alt }" />
                    </a>
                    <div class="minicart__item-details">
                        <a class="minicart__item-title" href="${ url }">${ title }</a>
                        <div class="minicart__item-subtotal">
                          <div class="item__variant">
                            <span>${ variant } <span class="item__quantity">Qty: ${ quantity }</span></span>
                          </div>
                          <div class="item__price">
                            <span>${ money }</span>
                          </div>
                        </div>
                    </div>
                </div>
              `;

                $html.push($item);

            });

            cartItems.innerHTML = $html.join('');
            cartTotal.innerText = subtotal;
            // cartCount.innerText = json_response.count;

            cartCount.forEach((cart) => {
              cart.innerText = json_response.count;
            });

            console.log(json_response.count);
            // cartCount.innerText = subtotal;

        },
        error: function (status) {
            console.warn('ERROR', status);
        }
    });
}

var add_to_cart = document.querySelectorAll('.js-add-to-cart');
for (var i = 0; i < add_to_cart.length; i++) {
    var current = add_to_cart[i];
    current.addEventListener('click', addToCart, false);
}


function openCart(elem) {
    cart.classList.add('active');
    document.body.classList.add("menu-open");
}

function toggleCart(elem) {
    cart.classList.toggle('active');
    document.body.classList.toggle("menu-open");
}

var toggle = document.querySelectorAll('.js-toggle-cart');
for (var i = 0; i < toggle.length; i++) {
    toggle[i].addEventListener('click', toggleCart, false);
}


function updateQuantity(elem) {

    if (elem.classList.contains('less')) {

        let input = elem.nextElementSibling;
        input.value--;

        let qty = input.value,
            id = input.dataset.id;

        $.post('/cart/change.js', {
                    quantity: qty,
                    id: id
                },
                null,
                "json"
            )
            .done(function () {
                updateCart();
            });

    } else if (elem.classList.contains('more')) {

        let input = elem.previousElementSibling;
        input.value++;

        let qty = input.value,
            id = input.dataset.id;

        console.log(id);

        $.post('/cart/change.js', {
                    quantity: qty,
                    id: id
                },
                null,
                "json"
            )
            .done(function () {
                console.log('test?');
                updateCart();
            });

    }
}

function removeItem(elem) {

    let id = elem.dataset.id;

    $.post('/cart/change.js', {
                quantity: 0,
                id: id
            },
            null,
            "json"
        )
        .done(function () {
            updateCart();
        });

}

function hasClass(elem, className) {
  if (className && className.includes(' ')) {
    return elem.className.split(' ').indexOf(className) > -1;
  } else if (className) {
    return elem.className == className;
  }
}

document.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-remove-item')) {
        removeItem(e.target);
    } else if (e.target.classList.contains('js-update-qty')) {
        updateQuantity(e.target);
    }
}, false);
